import React, { useState, useEffect } from 'react';
import './GetAQuoteMotor.css';
import FormsHeading from './FormsHeading';
import QuoteResultModal from './QuoteResultModal';
import { submitFormPayload, getApiBaseUrl } from '../utils/formSubmission';
import { buildMotorPremiumPayload } from '../utils/premiumPayloads';

function GetAQuoteMotor() {
    const [submitState, setSubmitState] = useState({ loading: false, message: '' });
    const [quoteResult, setQuoteResult] = useState(null);

    // API-driven dropdown states
    const [policyTypes, setPolicyTypes] = useState([]);
    const [selectedPolicyCode, setSelectedPolicyCode] = useState('');
    const [vehicleUsages, setVehicleUsages] = useState([]);
    const [selectedVehicleUsageCode, setSelectedVehicleUsageCode] = useState('');
    const [countries, setCountries] = useState([]);
    const [registrationYear, setRegistrationYear] = useState('');

    // Fetch policy types on mount
    useEffect(() => {
        const fetchPolicyTypes = async () => {
            try {
                const baseUrl = getApiBaseUrl();
                const res = await fetch(`${baseUrl}/api/RisksCovers/productRisk`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ PRD_CODE: '6000' })
                });
                const data = await res.json();
                setPolicyTypes(Array.isArray(data) ? data : []);
            } catch (err) {
                console.error('Failed to fetch policy types:', err);
            }
        };
        fetchPolicyTypes();
    }, []);

    // Fetch countries on mount
    useEffect(() => {
        const fetchCountries = async () => {
            try {
                const baseUrl = getApiBaseUrl();
                const res = await fetch(`${baseUrl}/api/countryload/lov`);
                const data = await res.json();
                setCountries(Array.isArray(data) ? data : []);
            } catch (err) {
                console.error('Failed to fetch countries:', err);
            }
        };
        fetchCountries();
    }, []);

    // Fetch vehicle usages when policy type or registration year changes
    useEffect(() => {
        if (!selectedPolicyCode || !registrationYear) {
            setVehicleUsages([]);
            return;
        }
        const fetchVehicleUsages = async () => {
            try {
                const baseUrl = getApiBaseUrl();
                const res = await fetch(`${baseUrl}/api/MotorRisksCovers/motorRisk`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ PRD_CODE: selectedPolicyCode, REG_YEAR: registrationYear })
                });
                const data = await res.json();
                setVehicleUsages(Array.isArray(data) ? data : []);
            } catch (err) {
                console.error('Failed to fetch vehicle usages:', err);
            }
        };
        fetchVehicleUsages();
    }, [selectedPolicyCode, registrationYear]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        const formElement = event.currentTarget;
        setSubmitState({ loading: true, message: '' });

        try {
            const formValues = Object.fromEntries(new FormData(formElement).entries());
            formValues.policyTypeCode = selectedPolicyCode;
            formValues.vehicleUsageCode = selectedVehicleUsageCode;
            const payload = buildMotorPremiumPayload(formValues);
            const result = await submitFormPayload('/api/premium/motor', payload);

            if (result.skipped) {
                setSubmitState({ loading: false, message: '' });
                return;
            }

            setQuoteResult(result.data || result.raw || null);
            setSubmitState({ loading: false, message: '' });
            formElement.reset();
            setSelectedPolicyCode('');
            setSelectedVehicleUsageCode('');
            setRegistrationYear('');
        } catch (error) {
            setSubmitState({ loading: false, message: '' });
            setQuoteResult({ error: error.message || 'Submission failed. Please try again.' });
        }
    };

  return (
        <div className='GetAQuoteMotor'>
            <div>
                <FormsHeading text='Personal  Details' />
            </div>
            <div className='GetAQuoteMotor_Forms'> 
                <form onSubmit={handleSubmit}> 
                    <div className='GetAQuoteMotor_TopQuery_Tri'>
                        <div className='GetAQuoteMotor_InputBox_Query'>
                            <label for="fname">Fullname: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="text" name="fullName" placeholder="Please enter your fullname" required />
                        </div>
                        <div className='GetAQuoteMotor_InputBox_Query'>
                            <label for="fname">Phone: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="tel" name="phone" placeholder="Enter your contact here" required />
                        </div>
                        <div className='GetAQuoteMotor_InputBox_Query'>
                            <label for="fname">Email Address: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="email" name="email" placeholder="Enter your email number" required />
                        </div>
                    </div>
                    <FormsHeading text='Policy  Details' />
                    <div className='GetAQuoteMotor_TopQuery_Tri'>
                        <div className='GetAQuoteMotor_InputBox_Query'>
                            <label for="fname">Policy type: <span style={{color : 'red'}}>*</span></label><br/>
                            <select
                                name="policyType"
                                required
                                value={selectedPolicyCode}
                                onChange={(e) => {
                                    setSelectedPolicyCode(e.target.value);
                                    setSelectedVehicleUsageCode('');
                                    setVehicleUsages([]);
                                }}
                            >
                                <option value="">Select policy type</option>
                                {policyTypes.map((pt) => (
                                    <option key={pt.RISK_CODE} value={pt.RISK_CODE}>{pt.RISK_NAME}</option>
                                ))}
                            </select>
                        </div>
                        <div className='GetAQuoteMotor_InputBox_Query'>
                            <label for="fname">Currency: <span style={{color : 'red'}}>*</span></label><br/>
                            <select name="currency" required defaultValue="GMD">
                                <option value="GMD">GMD</option>
                            </select>
                        </div>
                        <div className='GetAQuoteMotor_InputBox_Query'>
                            <label for="fname">Country: <span style={{color : 'red'}}>*</span></label><br/>
                            <select name="country" required defaultValue="GM">
                                <option value="">Select country</option>
                                {countries.map((c) => (
                                    <option key={c.CODE} value={c.CODE}>{c.NAME}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className='GetAQuoteMotor_MiddleQuery'>
                        <div className='GetAQuoteMotor_InputBox_Query'>
                            <label for="fname">Registration Year: <span style={{color : 'red'}}>*</span></label><br/>
                            <input
                                type="number"
                                min="1900"
                                max="2100"
                                name="registrationYear"
                                placeholder="Enter registration year"
                                required
                                value={registrationYear}
                                onChange={(e) => setRegistrationYear(e.target.value)}
                            />
                        </div>
                        <div className='GetAQuoteMotor_InputBox_Query'>
                            <label for="fname">Vehicle usage: <span style={{color : 'red'}}>*</span></label><br/>
                            <select
                                name="vehicleUsage"
                                required
                                value={selectedVehicleUsageCode}
                                onChange={(e) => setSelectedVehicleUsageCode(e.target.value)}
                                disabled={!selectedPolicyCode || !registrationYear}
                            >
                                <option value="">{!selectedPolicyCode || !registrationYear ? 'Select policy type & year first' : 'Select vehicle usage'}</option>
                                {vehicleUsages.map((vu) => (
                                    <option key={vu.RISK_CODE} value={vu.RISK_CODE}>{vu.RISK_NAME}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className='GetAQuoteMotor_TopQuery'>
                        <div className='GetAQuoteMotor_InputBox_Query'>
                            <label for="fname">Cubic Capacity (CC): <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="number" min="0" placeholder="Select Capacity" required name="cubicCapacity" list="exampleCover6"/>
                                <datalist id="exampleCover6" style={{backgroundColor: 'green'}}>
                                    <option value="Less than or Equal to 1600" />  
                                    <option value="Between 1601 and 2000" />
                                    <option value="Above 2000" />
                                </datalist>
                        </div>
                        <div className='GetAQuoteMotor_InputBox_Query'>
                            <label for="fname">Seating Capacity: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="number" min="1" name="seatingCapacity" placeholder="Enter your number of seats" required />
                        </div>
                        <div className='GetAQuoteMotor_InputBox_Query'>
                            <label for="fname">Vehicle Registration: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="text" name="vehicleRegistration" placeholder="Enter your vehicle number" required />
                        </div>
                        <div className='GetAQuoteMotor_InputBox_Query'>
                            <label for="fname">Year of Manufacture: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="number" min="1900" max="2100" placeholder="Select year of make" required name="yearOfManufacture" />
                        </div>
                    </div>
                    <div className='GetAQuoteMotor_MiddleQuery'>
                        <div className='GetAQuoteMotor_InputBox_Query'>
                            <label for="fname">Start Date: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="date" name="startDate" placeholder="Enter Commencement Date" required />
                        </div>
                        <div className='GetAQuoteMotor_InputBox_Query'>
                            <label for="fname">End Date: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="date" name="endDate" placeholder="Enter Expiration Date" required />
                        </div>
                    </div>
                    <div className='GetAQuoteMotor_TopQuery'>
                        <div className='GetAQuoteMotor_InputBox_Query'>
                            <label for="fname">Vehicle Value: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="number" min="0" step="0.01" name="vehicleValue" placeholder="Enter value of car" required />
                        </div>
                        <div className='GetAQuoteMotor_InputBox_Query'>
                            <label for="fname">Standard TPPD Limit is 2000: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="text" placeholder="Select" required name="extraTppd" list="exampleCover5"/>
                                <datalist id="exampleCover5" style={{backgroundColor: 'green'}}>
                                    <option value="Yes" />  
                                    <option value="No" />
                                </datalist>
                        </div>
                        <div className='GetAQuoteMotor_InputBox_Query'>
                            <label for="fname">Buy Extra TPPD Limit: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="number" min="0" step="0.01" name="extraTppdAmount" placeholder="Extra Tppd Limit amount" required />
                        </div>
                        <div className='GetAQuoteMotor_InputBox_Query'>
                            <label for="fname">Buy Back Excess?: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="text" placeholder="Select" required name="buyBackExcess" list="exampleCover5"/>
                                <datalist id="exampleCover5" style={{backgroundColor: 'green'}}>
                                    <option value="Yes" />  
                                    <option value="No" />
                                </datalist>
                        </div>
                    </div>
                    <div className="submitAction" >
                        <input className='FormSubmit' type="submit" value={submitState.loading ? 'SUBMITTING...' : 'SUBMIT'} disabled={submitState.loading} />
                    </div>
                    <QuoteResultModal data={quoteResult} onClose={() => setQuoteResult(null)} />
                </form>
            </div>
        </div>
    )
}

export default GetAQuoteMotor;
